import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useTranslation } from "../../hooks/useTranslation";
/**
 * Use the `FormattedMessage` if you need translated text
 *
 * By default FormattedMessage will render the formatted string into a
 * <React.Fragment>.
 *
 * For details see the documentation of the `i18n` property.
 */
export const FormattedMessage = (props) => {
    const { i18n, as: Container = React.Fragment, children } = props;
    const translate = useTranslation();
    if (i18n === undefined) {
        return _jsx(_Fragment, { children: children });
    }
    const translated = translate(i18n);
    if (translated === null) {
        return null;
    }
    return _jsx(Container, { children: translated });
};
export default FormattedMessage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRm9ybWF0dGVkTWVzc2FnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0Zvcm1hdHRlZE1lc3NhZ2UvRm9ybWF0dGVkTWVzc2FnZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sS0FBYSxNQUFNLE9BQU8sQ0FBQztBQUNsQyxPQUFPLEVBQWtCLGNBQWMsRUFBRSxNQUFNLDRCQUE0QixDQUFDO0FBSzVFOzs7Ozs7O0dBT0c7QUFDSCxNQUFNLENBQUMsTUFBTSxnQkFBZ0IsR0FBOEIsQ0FBQyxLQUFLLEVBQUUsRUFBRTtJQUNuRSxNQUFNLEVBQUUsSUFBSSxFQUFFLEVBQUUsRUFBRSxTQUFTLEdBQUcsS0FBSyxDQUFDLFFBQVEsRUFBRSxRQUFRLEVBQUUsR0FBRyxLQUFLLENBQUM7SUFDakUsTUFBTSxTQUFTLEdBQUcsY0FBYyxFQUFFLENBQUM7SUFFbkMsSUFBSSxJQUFJLEtBQUssU0FBUyxFQUFFLENBQUM7UUFDdkIsT0FBTyw0QkFBRyxRQUFRLEdBQUksQ0FBQztJQUN6QixDQUFDO0lBRUQsTUFBTSxVQUFVLEdBQUcsU0FBUyxDQUFDLElBQUksQ0FBQyxDQUFDO0lBRW5DLElBQUksVUFBVSxLQUFLLElBQUksRUFBRSxDQUFDO1FBQ3hCLE9BQU8sSUFBSSxDQUFDO0lBQ2QsQ0FBQztJQUVELE9BQU8sS0FBQyxTQUFTLGNBQUUsVUFBVSxHQUFhLENBQUM7QUFDN0MsQ0FBQyxDQUFDO0FBRUYsZUFBZSxnQkFBZ0IsQ0FBQyJ9